/**
 * Generated-avatar helpers: deterministic initials + brand gradient SVG data URI.
 * Kept separate from the component so the component module only exports a component
 * (satisfies react-refresh/only-export-components).
 */

/**
 * Derive up to two uppercase initials from a name.
 * "Jane A. Doe" -> "JD", "Madonna" -> "M".
 */
export function initialsFromName(name) {
  const parts = String(name || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length === 0) return 'Z';
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

/** Stable 32-bit hash of a string for deterministic per-name styling. */
export function hashName(name) {
  let h = 0;
  const s = String(name || '');
  for (let i = 0; i < s.length; i++) {
    h = (h * 31 + s.charCodeAt(i)) >>> 0;
  }
  return h;
}

/** Two brand-family gradient stops derived deterministically from the name. */
export function gradientStops(name) {
  const h = hashName(name);
  const maroons = ['#7B1E2B', '#8E1F2E', '#641824', '#9A2436'];
  const golds = ['#C99A2E', '#D4AF37', '#B8860B', '#E0B645'];
  return {
    from: maroons[h % maroons.length],
    to: golds[(h >> 3) % golds.length],
  };
}

/**
 * Build a self-contained SVG data URI showing the member's initials on a
 * maroon -> gold brand gradient. Works offline and satisfies `img-src 'self' data:`.
 */
export function initialsDataUri(name, size = 160) {
  const initials = initialsFromName(name);
  const { from, to } = gradientStops(name);
  const id = `g${hashName(name).toString(36)}`;
  const fontSize = Math.round(size * 0.4);
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}" role="img">
  <defs><linearGradient id="${id}" x1="0" y1="0" x2="1" y2="1">
    <stop offset="0" stop-color="${from}"/><stop offset="1" stop-color="${to}"/>
  </linearGradient></defs>
  <rect width="${size}" height="${size}" fill="url(#${id})"/>
  <text x="50%" y="50%" dy="0.35em" text-anchor="middle" fill="#ffffff"
    font-family="Georgia, 'Times New Roman', serif" font-size="${fontSize}" font-weight="700"
    letter-spacing="1">${initials}</text>
</svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
}
